import { render, staticRenderFns } from "./ExtraTable.vue?vue&type=template&id=c5c85816&scoped=true"
import script from "./ExtraTable.vue?vue&type=script&lang=ts"
export * from "./ExtraTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5c85816",
  null
  
)

export default component.exports